import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-crop",
  templateUrl: "./med-icon-crop.component.html",
})
export class MedIconCropComponent extends SvgMixinComponent {}
